import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IoMdTime } from 'react-icons/io';

import { RegularText } from '../../common/Text';
import { fontSize } from '../../../utils';

const OuterContainer = styled.div`
  display: flex;
  align-items: center;
  background: RGBA(136, 37, 204, 0.1);
  padding: 0.875rem;
`;

const TimeIcon = styled(IoMdTime)`
  color: #8852cc;
  margin-right: 1rem;
  font-size: ${fontSize(1.25)};
`;

const Text = styled(RegularText)`
  font-size: ${fontSize(0.6)};
  flex: 1;
`;

const DoctorUnavailableMessage = ({ label }) => (
  <OuterContainer>
    <TimeIcon />
    <Text>{label}</Text>
  </OuterContainer>
);

DoctorUnavailableMessage.propTypes = {
  label: PropTypes.string,
};

export default DoctorUnavailableMessage;
